import React from 'react';

import { Box, Tooltip, useMantineTheme } from '@mantine/core';
import { IconEye, IconEyeOff } from '@tabler/icons-react';

interface WorkoutVisibilityIconProps {
  visible: boolean;
  visibleColor?: string;
  withinPortal?: boolean;
}

const WorkoutVisibilityIcon = ({
  visible,
  visibleColor,
  withinPortal = false,
}: WorkoutVisibilityIconProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Tooltip
      label={visible ? 'Visible to athletes' : 'Hidden from athletes'}
      withArrow
      position='top'
      withinPortal={withinPortal}
    >
      <Box sx={{ display: 'flex', flexShrink: 0 }} onClick={e => e.stopPropagation()}>
        {visible ? (
          <IconEye size={14} color={visibleColor ?? theme.colors.gray[7]} />
        ) : (
          <IconEyeOff size={14} color={theme.colors.gray[5]} />
        )}
      </Box>
    </Tooltip>
  );
};

export default WorkoutVisibilityIcon;
